<template>
  <div>
    <h2 class="subtitle">Options du site internet</h2>
    <hr />
    <projects_figuration></projects_figuration>
  </div>
</template>

<script>
import Projects_figuration from "./Projects_figuration";
export default {
  name: "WebsiteProjects",
  components: { Projects_figuration }
};
</script>
